module.exports = __webpack_public_path__ + "media/images/elasticity_graph-4f22715c76224c1bf52d1372db71642b.svg";